export const DNAOnboardStatus = {
    ONBOARD_DNA_MERCHANT: 'onBoardDnaMerchant',
    CANCEL_DNA_ONBOARD: 'cancelDnaOnboard',
    ONBOARDING_INITIAED: 'DnaOnboardIntiated',
    EXTRA_PDQ: 'extraPdqRequest',
    COMPLETED_ONBOARDING: 'OnboardingComplete'
};
